import { ANIMATION_DURATION } from "components/Message/configs";
import MessageForm from "components/Message/Form";
import styled from "styled-components";
import { getAppearFromLeft } from "theme/animations";
import { breakpoints } from "theme/breakpoints";

interface ContainerProps {
  isFormVisible: boolean;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  z-index: 1;
  display: flex;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.light};
  width: ${({ isFormVisible }) => (isFormVisible ? 100 : 50)}%;
  overflow: hidden;
  transition: width ${ANIMATION_DURATION}, max-height ${ANIMATION_DURATION};
  animation: ${getAppearFromLeft("-20%")} 1s;
  animation-delay: 1.5s;
  animation-fill-mode: both;

  @media (max-width: ${breakpoints.lg}) {
    width: 100%;
    flex-direction: column;
  }
`;

export const StyledMessageForm = styled(MessageForm)`
  box-sizing: border-box;
  min-width: 50vw;
  padding: 20px 5vw 20px 0;
  gap: 10px;

  @media (max-width: ${breakpoints.lg}) {
    padding: 20px 5vw;
  }
`;
